import AppConfigReducerInitialState from '../reducers/AppConfigReducer/AppConfigReducerInitialState';

/** Get the app config. */
export const getAppConfig = () => {
  // Get the site config from the Drupal settings.
  let appConfig = AppConfigReducerInitialState;

  if (
    typeof window.drupalSettings !== 'undefined'
    && window.drupalSettings.cust_account_app !== 'undefined'
  ) {
    appConfig = window.drupalSettings.cust_account_app;
  }

  return appConfig;
};

/** Get the API Base Url from the the app config. */
export const getApiBaseUrl = () => {
  let apiBaseUrl = `//${window.location.hostname}/api`;
  const appConfig = getAppConfig();
  if (
    typeof appConfig !== 'undefined'
    && typeof appConfig.api_base_url !== 'undefined' && appConfig.api_base_url !== ''
  ) {
    apiBaseUrl = appConfig.api_base_url;
  }
  return apiBaseUrl;
};

/** Get the API Base Url from the the app config. */
export const getGapiBaseUrl = () => {
  const apiBaseUrl = `//${window.location.hostname}`;
  return apiBaseUrl;
};

/** Get the site config. */
export const getSiteConfig = () => {
  const langs = {
    depositEnabledLangs: ['en', 'en-ie'],
    giroPayEnabledLangs: ['de-de'],
    paypalEnableLangs: ['en', 'en-ie', 'de-de'],
    idealPayEnabledLangs: ['en-nl'],
    idealPayEnabledCountry: 'Netherlands',
  };
  return langs;
};

export const getCountryCodes = () => {
  const countryCodes = {
    en: '44',
    'en-us': '1',
    'en-nl': '31',
    'en-au': '43',
    'en-ie': '353',
    'de-de': '49',
  };
  return countryCodes;
};

export const getWhatsappNumbers = () => {
  const whatsappPhoneNumbers = {
    en: '+448002230322',
  };
  return whatsappPhoneNumbers;
};

export const getOpeningTimes = () => {
  const openingTimes = {
    en: '9:00am-7:00pm Monday to Friday 9:00am-3:00pm on Saturdays 9:00am-3:00pm Sundays 10:00am-3:00pm bank holidays',
    'en-ie': '9:00am-7:00pm Monday to Friday 9:00am-5:00pm on Saturday 10:00am-3:00pm on Sunday 10:00am-3:00pm bank holidays',
    'en-nl': '10:00am - 8:00pm Monday to Friday 10:00am - 4:00pm on Saturdays 10:00am - 4:00pm Sundays',
    'de-de': 'Montag bis Freitag: 10:00 - 16:30 Uhr',
  };

  return openingTimes;
};

const domainUrl = window.location.hostname;

export const getTermsAndPolicyConfig = () => {
  let termsAndPolicyCofig = {};
  if (domainUrl.match(/seaworldparks|sw|seaworld/)) {
    termsAndPolicyCofig = {
      termsLink: 'booking_conditions',
      policyLink: 'privacy_policy',
    };
  } else if (domainUrl.match(/universal-bookings|uo|orlando|universal/)) {
    termsAndPolicyCofig = {
      termsLink: 'terms_conditions',
      policyLink: 'privacy_policy',
    };
  } else if (domainUrl.match(/attractiontickets|global|localhost/)) {
    termsAndPolicyCofig = {
      termsLink: '4239',
      policyLink: '4240',
    };
  } else {
    termsAndPolicyCofig = {
      termsLink: 'terms_conditions',
      policyLink: 'privacy_policy',
    };
  }
  return termsAndPolicyCofig;
};

export const getLangPrefixFromBrand = (brand) => {
  const langs = window?.drupalSettings?.cust_account_app?.request_geo_params;

  if (!langs) {
    return null;
  } if (brand) {
    return langs[brand];
  }
  return langs;
};

export const getLangUrlFromBrand = (brand) => {
  const langs = window?.drupalSettings?.cust_account_app?.url_geo_params;

  if (!langs) {
    return null;
  } if (brand) {
    return langs[brand];
  }
  return langs;
};
